import type * as React from 'react'
import { badgeVariants } from '@/components/ui/badge'
import { statusLabel, statusTone } from '@/lib/status-tone'
import { cn } from '@/lib/utils'

interface StatusBadgeProps extends React.ComponentProps<'span'> {
  /** An inquiry, consignment, or operational status as the API returns it. */
  status: string | null | undefined
  /** Overrides the derived label; the tone still comes from `status`. */
  label?: string
}

/**
 * The one way Helm shows a record's status. The colour comes from what the
 * status means (see `statusTone`), not from which screen draws it, so
 * "Awaiting Payment" looks the same on the dashboard, the list, and the record.
 */
export function StatusBadge({ status, label, className, ...props }: StatusBadgeProps) {
  const tone = statusTone(status)
  return (
    <span
      data-slot="status-badge"
      data-tone={tone}
      className={cn(badgeVariants({ variant: 'status' }), `tone-${tone}`, className)}
      {...props}
    >
      {label ?? statusLabel(status)}
    </span>
  )
}
